
import { defineComponent, getCurrentInstance } from 'vue'
import { useFilters } from '../../../../composables/use-filters'
import { capitalizeSentence } from '../../../../filters'
import { FiltersUtils, StringUtils } from '../../../../utils'
import CopyToClipboard from '../../../shared/copy-to-clipboard.component.vue'

export default defineComponent({
  name: 'AuditItemDetailsFieldValue',
  components: {
    CopyToClipboard,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Date],
      default: '',
    },
    copyToClipboard: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const currentInstance = getCurrentInstance()
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const { filters } = useFilters()

    const isLink = typeof props.value === 'string' && StringUtils.isLink(props.value)
    const valueText = getValue()

    const component = props.copyToClipboard ? CopyToClipboard : 'div'

    function parseDate(date: Date): string {
      return date.toLocaleDateString(currentInstance.proxy.$epb.locale, {
        hourCycle: 'h23',
        hour: '2-digit',
        minute: '2-digit',
      })
    }

    function getValue(): string {
      if (props.value instanceof Date) {
        return parseDate(props.value)
      }

      const value = props.value.toString()
      return getFilterLabel(value) ?? capitalizeSentence(value)
    }

    function getFilterLabel(filterId: string): string | undefined {
      if (!filters.value[filterId]) {
        return
      }

      return FiltersUtils.getLabel(filters.value[filterId].config, $epb.messages.filters)
    }

    return {
      isLink,
      valueText,
      component,
    }
  },
})
